import { IMAGES } from "./images";

// Products mock data. Backend: replace via productsService.getProducts()
// NOTE: Technical specifications are intentionally EMPTY placeholders — no
// specifications have been invented. Descriptions are neutral, editable
// placeholders and should be replaced with real content from the backend/CMS.

const slugify = (str) =>
  str
    .toLowerCase()
    .replace(/™/g, "")
    .replace(/&/g, "and")
    .replace(/\|/g, " ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const placeholderDesc = (name) =>
  `Detailed product information for ${name} will be provided by our team. Contact Athena Scientific for full specifications, documentation and application support tailored to your laboratory.`;

const shortDesc =
  "Contact our team for detailed specifications, documentation and application support.";

// [name, categorySlug, brandSlug, subcategorySlug|null]
const RAW = [
  // Water Purification — Neptec
  ["HALIOS & HALIOS ID", "water-purification-systems", "neptec", "ultrapure-water-type-1"],
  ["TRITON", "water-purification-systems", "neptec", "ultrapure-water-type-1"],
  ["TALOS", "water-purification-systems", "neptec", "ultrapure-water-type-1"],
  ["HALIOS 6 | 12 | 40", "water-purification-systems", "neptec", "ultrapure-pure-water-type-1-2"],
  ["HALIOS ID 6 | 12 | 40", "water-purification-systems", "neptec", "ultrapure-pure-water-type-1-2"],
  ["TRITON 6 | 12", "water-purification-systems", "neptec", "ultrapure-ro-water-type-1-3"],
  ["PROTEUS DI | EDI", "water-purification-systems", "neptec", "pure-water-type-2"],
  ["RO delta EDI", "water-purification-systems", "neptec", "pure-water-type-2"],
  ["TRITON DI 6 | 12", "water-purification-systems", "neptec", "pure-water-type-2"],
  ["HALIOS ID EDI 6 | 12 | 40", "water-purification-systems", "neptec", "pure-water-type-2"],
  ["RO alpha EDI", "water-purification-systems", "neptec", "pure-water-type-2"],
  ["RO alpha EDI PLUS", "water-purification-systems", "neptec", "pure-water-type-2"],
  ["TRITON RO 6 | 12", "water-purification-systems", "neptec", "ro-water-type-3"],
  ["RO delta", "water-purification-systems", "neptec", "ro-water-type-3"],
  ["RO alpha", "water-purification-systems", "neptec", "ro-water-type-3"],
  ["RO alpha EDI (Type 3)", "water-purification-systems", "neptec", "ro-water-type-3"],
  ["PROTEUS AS", "water-purification-systems", "neptec", "clrw-system"],
  ["NEREUS AS", "water-purification-systems", "neptec", "clrw-system"],
  // Glassware Washers — Eurping
  ["LW180D", "glassware-washers", "eurping", null],
  ["LW180Plus", "glassware-washers", "eurping", null],
  ["LW180Pro", "glassware-washers", "eurping", null],
  ["LW190", "glassware-washers", "eurping", null],
  ["LW190Plus", "glassware-washers", "eurping", null],
  ["LW220", "glassware-washers", "eurping", null],
  ["LW220H", "glassware-washers", "eurping", null],
  ["LW230", "glassware-washers", "eurping", null],
  ["LW230H", "glassware-washers", "eurping", null],
  ["LW320", "glassware-washers", "eurping", null],
  ["LW320H", "glassware-washers", "eurping", null],
  // Balances — Ohaus
  ["EXP225D/AD Explorer Plus™ Semi-Micro EXP Balance", "balances", "ohaus", null],
  ["EXP125/AD Explorer Plus™ Semi-Micro EXP Balance", "balances", "ohaus", null],
  ["PR124 Analytical Balance", "balances", "ohaus", null],
  ["PR224 Analytical Balance", "balances", "ohaus", null],
  ["PR523 Precision Balance", "balances", "ohaus", null],
  ["PR1602 Precision Balance", "balances", "ohaus", null],
  ["PR4202 Precision Balance", "balances", "ohaus", null],
  ["PR6201 Precision Balance", "balances", "ohaus", null],
];

const FEATURED = new Set([
  "halios-and-halios-id",
  "triton",
  "lw230",
  "pr124-analytical-balance",
  "proteus-as",
  "exp225d-ad-explorer-plus-semi-micro-exp-balance",
]);

export const PRODUCTS = RAW.map(([name, category, brand, sub], i) => {
  const slug = slugify(name);
  const heroImg = IMAGES.product[category];
  const catImg = IMAGES.category[category];
  return {
    id: `prod-${String(i + 1).padStart(3, "0")}`,
    name,
    slug,
    brand, // brand slug
    category, // category slug
    subcategory: sub, // subcategory slug or null
    shortDescription: shortDesc,
    description: placeholderDesc(name),
    specifications: [], // intentionally empty — no fabricated specs
    images: [heroImg, catImg],
    documents: [
      { id: `${slug}-brochure`, title: "Product Brochure", type: "PDF", url: "#", placeholder: true },
      { id: `${slug}-datasheet`, title: "Technical Datasheet", type: "PDF", url: "#", placeholder: true },
    ],
    videos: [], // mock embedded video URLs go here
    externalUrl: null, // manufacturer/product URL when available
    featured: FEATURED.has(slug),
    active: true,
  };
});

export const getProductBySlug = (slug) => PRODUCTS.find((p) => p.slug === slug);
